import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowOffsite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_16984_14688)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.5 0.5V5.26507H10.2076V2.70931L6.40778 6.50999L5.49401 5.59472L9.2938 1.79533H6.73605V0.502584L11.5 0.5ZM8.866 10.4012H1.60375V3.13462H5.02356V2.03061H0.5V11.5H9.97104V6.97538H8.86858L8.866 10.4012Z",
				fill: "#313131"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_16984_14688",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 12,
				height: 12,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgArrowOffsite);
export { ForwardRef as ReactComponent };
